// extracted by mini-css-extract-plugin
export default {"slide_container":"Slider_slide_container__MqjL5","icon_container":"Slider_icon_container__yaWdr","icon_box":"Slider_icon_box__USM3J","image":"Slider_image__Fk6Zs"};